import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {RequestsService} from './requests.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {ToastsManager} from 'ng6-toastr';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private requestService: RequestsService, public router: Router) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //let bearerType = request.headers.getAll('Authorization')[0].match('Basic')[0];
    let basicTest = request.headers.getAll('Authorization');
    if (!request.headers.getAll('Authorization')) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${atob(this.requestService.getToken())}`
          }
        });
    }
    return next.handle(request).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            if (event.body.code) {
              if (event.body.code == 401) {
                this.router.navigate(['/logout']);
                //this.toastr.error(event.body.message, event.body.result_type);
              }
            }
           // console.log('INTERCEPTOR : api call success ->', event);
          }
        },
        error => {
          //this.router.navigate(['/login']);
          //console.log('INTERCEPTOR 2: api call error->', error);
        }
      ),
    );
  }


}
